import { WalkthroughState } from "./types";
import { WALKTHROUGH_VERSION } from "./walkthroughSteps";

const STORAGE_PREFIX = "ekluvya.walkthrough";

const initialState = (): WalkthroughState => ({
  shown: false,
  completed: false,
  skipped: false,
  version: WALKTHROUGH_VERSION,
  currentStep: 0,
  completedAt: null,
  skippedAt: null,
  updatedAt: new Date().toISOString(),
});

export const walkthroughStorage = {
  key(userId = "default") {
    return `${STORAGE_PREFIX}.${userId}`;
  },

  read(userId?: string): WalkthroughState {
    try {
      const raw = localStorage.getItem(this.key(userId));
      if (!raw) return initialState();
      const stored = JSON.parse(raw) as Partial<WalkthroughState>;
      const shown =
        stored.shown === true ||
        stored.completed === true ||
        stored.skipped === true;
      if (stored.version !== WALKTHROUGH_VERSION) {
        return { ...initialState(), shown };
      }
      return {
        ...initialState(),
        ...stored,
        shown,
        version: WALKTHROUGH_VERSION,
      };
    } catch {
      return initialState();
    }
  },

  write(userId: string | undefined, patch: Partial<WalkthroughState>) {
    const next = {
      ...this.read(userId),
      ...patch,
      version: WALKTHROUGH_VERSION,
      updatedAt: new Date().toISOString(),
    };
    try {
      localStorage.setItem(this.key(userId), JSON.stringify(next));
    } catch (error) {
      console.warn("Unable to save walkthrough progress", error);
    }
    return next;
  },
};
